import { render } from "./Marketing_Campaigns.vue?vue&type=template&id=ae47842a&scoped=true"
import script from "./Marketing_Campaigns.vue?vue&type=script&lang=js"
export * from "./Marketing_Campaigns.vue?vue&type=script&lang=js"

import "./Marketing_Campaigns.vue?vue&type=style&index=0&id=ae47842a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae47842a"]])

export default __exports__